import { Component, OnInit, EventEmitter, Output, Input } from '@angular/core';
import { DataService } from '../dataService.service';
import{UserInfo} from '../userInfo'
@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.css']
})
export class HeaderComponent implements OnInit {

  @Input() UserInfos: UserInfo;
   
  
  constructor(private dataService: DataService ) { 
  
  }

  ngOnInit() {
  
   
  }
  

 
}
